import React from "react";
import NavBar from "./NavBar";
const Header = () => {
  return (
    <div className="Headerposition">
      <NavBar />
    </div>
  );
};

export default Header;
